import { apiClient, Auth, HttpError } from '@/shared/api'

import { THostRoomPreviewResponse } from './schema'

export const getHostRoomPreview = async ({ roomId }: { roomId: number }) => {
  try {
    const { data } = await apiClient.get<THostRoomPreviewResponse>({
      endpoint: `/host/rooms/${roomId}/preview`,
      auth: Auth.REQUIRED,
    })

    return {
      response: data,
      error: null,
    }
  } catch (error) {
    if (error instanceof HttpError) {
      return {
        response: null,
        error: error.code,
      }
    }

    return {
      response: null,
      error,
    }
  }
}
